import angular from 'angular';

import CategorySelectModalComponent from './category-select-modal.cmpt';

export default angular
    .module('application.component.modals.component.category-select-modal', [])
    .component(CategorySelectModalComponent.selector, CategorySelectModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-select-modal/index.js